import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Toggle from "../../common/Toggle";
import { path } from "ramda";

export default class PermissionsTable extends Component {
  onSwitchChangeIfOff = (inputs) => {
    if (inputs.length > 1 && inputs[0].value === false) {
      inputs[1].value = false;
    }
  };

  buildSwitch = ({ inputs }, fields, disabled) => {
    const result = [];
    for (let i = 0; i < inputs.length; i++) {
      result.push(
        <Toggle
          className="big"
          disabled={disabled || this.props.disabled}
          field={inputs[i]}
          onChange={() => {
            this.onSwitchChangeIfOff(inputs);
            this.props.onChange(fields);
          }}
        />
      )
    }
    return result;
  };

  buildBodyTable = ({ carcass, fields }) => {
    const trs = [];

    const getStyle = function(idx) {
      return {
        fontWeight: 500,
        paddingLeft: fields[idx].indent * 10
      };
    }

    for (const line in fields) {
      const tds = [];

      const valueOfFirstCreateInput = path([line, 'permissions', 'view', 'inputs', 0, 'value'], fields);
      for (const row in carcass) {
        const currentRow = path([line, 'permissions', row], fields);
        const disabled = row !== 'view' && valueOfFirstCreateInput === false;
        tds.push(
          <td>
            {currentRow ? this.buildSwitch(currentRow, fields, disabled) : null}
          </td>
        );
      }
      trs.push(
        <tr>
          <td style={getStyle(line)}>{fields[line].label}</td>
          {tds}
        </tr>);
    }
    return (
      <tbody>
      {trs}
      </tbody>
    )
  };

  buildHeaderTable = ({ carcass }) => {
    const ths = [];
    for (const th in carcass) {
      ths.push(<th className="text-center">{carcass[th].label}</th>);
    }
    return (
      <thead>
      <tr>
        <th>Permission Type</th>
        {ths}
      </tr>
      </thead>
    )
  };

  render() {
    const { permissions } = this.props;
    return (
      <table className="table">
        {this.buildHeaderTable(permissions)}
        {this.buildBodyTable(permissions)}
      </table>
    )
  };
}

PermissionsTable.propTypes = {
  disabled: PropTypes.bool,
  permissions: PropTypes.object,
  onChange: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/сomponents/PermissionsTable/index.js